import MultiquoteCarPermissions from './MultiquoteCarPermissions'
import MultiquoteHomePermissions from './MultiquoteHomePermissions'
import MultiquoteCommercePermissions from './MultiquoteCommercePermissions'
import MultiquoteConsortiumPermissions from './MultiquoteConsortiumPermissions'
import MultiquoteMotorcyclePermissions from './MultiquoteMotorcyclePermissions'
import MultiquoteLifePermissions from './MultiquoteLifePermissions'
import MultiquoteBicyclePermissions from './MultiquoteBicyclePermissions'
import MultiquoteComputerPermissions from './MultiquoteComputerPermissions'
import MultiquotePhonePermissions from './MultiquotePhonePermissions'
import MultiquoteMobilityPermissions from './MultiquoteMobilityPermissions'
import MultiquoteDebugPermissions from './MultiquoteDebugPermissions'
import MultiquoteErrorPermissions from './MultiquoteErrorPermissions'
import MultiquoteFullCoveragesPermissions from './MultiquoteFullCoveragesPermissions'

class MultiquotePermissions {
    constructor({ 
        car, 
        motorcycle, 
        home, 
        commerce, 
        consortium,
        life,
        bicycle,
        computer,
        phone,
        mobility,
        debug = {},
        error = {},
        fullCoverages = {},
    }) {
        this.car = new MultiquoteCarPermissions(car)
        this.motorcycle = new MultiquoteMotorcyclePermissions(motorcycle)
        this.home = new MultiquoteHomePermissions(home)
        this.commerce = new MultiquoteCommercePermissions(commerce)
        this.consortium = new MultiquoteConsortiumPermissions(consortium)
        this.life = new MultiquoteLifePermissions(life)
        this.bicycle = new MultiquoteBicyclePermissions(bicycle)
        this.computer = new MultiquoteComputerPermissions(computer)
        this.phone = new MultiquotePhonePermissions(phone)
        this.mobility = new MultiquoteMobilityPermissions(mobility)
        this.debug = new MultiquoteDebugPermissions(debug)
        this.error = new MultiquoteErrorPermissions(error)
        this.fullCoverages = new MultiquoteFullCoveragesPermissions(fullCoverages)
    }
}

export default MultiquotePermissions
